import React, { useState } from 'react';
import { changeAdminPassword } from '../../utils/api';

const Settings = ({ adminInfo, flash, onLogout }) => {
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [changing, setChanging] = useState(false);

  const handleChange = async () => {
    if (!form.currentPassword || !form.newPassword) { flash('Fill all fields', 'error'); return; }
    if (form.newPassword.length < 6) { flash('Min 6 characters', 'error'); return; }
    if (form.newPassword !== form.confirmPassword) { flash('Passwords do not match', 'error'); return; }
    setChanging(true);
    try { await changeAdminPassword({ currentPassword: form.currentPassword, newPassword: form.newPassword }); flash('Password changed'); setForm({ currentPassword: '', newPassword: '', confirmPassword: '' }); }
    catch (e) { flash(e.response?.data?.error || 'Failed', 'error'); }
    setChanging(false);
  };

  return (
    <div className="fade-in">
      <h2 className="adm-title">Settings</h2>
      <div className="card adm-sub" style={{ marginTop: 0 }}>
        <h3>Account</h3>
        <div className="adm-settings-info">
          <div className="adm-settings-row"><span>Username</span><strong className="mono">{adminInfo?.username}</strong></div>
          <div className="adm-settings-row"><span>Name</span><strong>{adminInfo?.name}</strong></div>
          <div className="adm-settings-row"><span>Role</span><strong className="adm-role-badge">{adminInfo?.role}</strong></div>
        </div>
      </div>
      <div className="card adm-sub">
        <h3>Change Password</h3>
        <div className="adm-form-grid cols-1">
          <div className="adm-field"><label>Current Password</label><input type="password" value={form.currentPassword} onChange={e => setForm({ ...form, currentPassword: e.target.value })} className="input" autoComplete="current-password" /></div>
          <div className="adm-field"><label>New Password</label><input type="password" value={form.newPassword} onChange={e => setForm({ ...form, newPassword: e.target.value })} className="input" placeholder="Min 6 chars" autoComplete="new-password" /></div>
          <div className="adm-field"><label>Confirm</label><input type="password" value={form.confirmPassword} onChange={e => setForm({ ...form, confirmPassword: e.target.value })} className="input" autoComplete="new-password" /></div>
        </div>
        <button className="btn btn-primary adm-mt" onClick={handleChange} disabled={changing}>{changing ? 'Changing...' : 'Change Password'}</button>
      </div>
      <div className="card adm-sub">
        <h3>Session</h3>
        <p className="adm-hint">Logging out clears your session.</p>
        <button className="btn btn-outline danger" onClick={onLogout}>Logout</button>
      </div>
    </div>
  );
};

export default Settings;